import Api from "shared/service/api/api";

// actions
export const LOAD_PROJECT_CLIENTS = "loadClients";

//mutations
export const SET_PROJECT_CLIENTS = "setClients";

const state = {
  clients: {
    list: [],
    page: 1,
    page_count: 1,
  },
};

const actions = {
  [LOAD_PROJECT_CLIENTS]({ commit }, { page, search = "" }) {
    Api.project.client
      .all(page, search)
      .then((response) => {
        if (!response.success) {
          throw new Error(response.error);
        }

        commit(SET_PROJECT_CLIENTS, response.data);
      })
      .catch((e) => e);
  },
};

const mutations = {
  [SET_PROJECT_CLIENTS](state, { list, page, page_count }) {
    state.clients.list = list;
    state.clients.page = page;
    state.clients.page_count = page_count;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
